/**
 * Override the @automattic/charts default (300ms) for snappier resize response.
 */
export const RESIZE_DEBOUNCE_MS = 50;
